import $ from 'jquery'
import _ from 'lodash'

if (!Function.prototype.bind) {
  Function.prototype.bind = function (oThis) { // eslint-disable-line
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5 internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable')
    }
    let AArgs = Array.prototype.slice.call(arguments, 1)
    let FToBind = this
    let FNOP = function () { }
    let FBound = () => FToBind.apply(this instanceof FNOP && oThis ? this : oThis, AArgs.concat(Array.prototype.slice.call(arguments)))

    FNOP.prototype = this.prototype
    FBound.prototype = new FNOP()
    return FBound
  }
}

if (!Array.prototype.inArray) {
  Array.prototype.inArray = function (comparer, element) { // eslint-disable-line
    for (var i = 0; i < this.length; i++) {
      if (comparer) {
        if (comparer(this[i], element)) {
          return true
        }
      } else {
        if (this[i] === element) {
          return true
        }
      }
    }
    return false
  }
}

if (!Array.prototype.sumBy) {
  Array.prototype.sumBy = function (field) { // eslint-disable-line
    return _.sumBy(this, item => {
      return item[field]
    })
  }
}

if (!Array.prototype.isDistinct) {
  Array.prototype.isDistinct = function () {
    var cleaned = this.filter(x => x) // remove null values therefore the result is accurate
    return cleaned.length === new Set(cleaned).size
  }
}

if (!Array.prototype.tryPush) {
  Array.prototype.tryPush = function (element, comparer) { // eslint-disable-line
    if (!this.inArray(comparer, element)) {
      this.push(element)
      return true
    }
    return false
  }
}

if (!Array.prototype.tryRemove) {
  Array.prototype.tryRemove = function (element, comparer) { // eslint-disable-line
    if (!comparer) {
      comparer = (el) => el === element
    }
    var index = this.findIndex(el => comparer(el, element))
    if (index > -1) {
      this.splice(index, 1)
      return true
    }

    return false
  }
}

if (!Array.prototype.first) {
  Array.prototype.first = function () { // eslint-disable-line
    return _.head(this)
  }
}

if (!Array.prototype.last) {
  Array.prototype.last = function () { // eslint-disable-line
    return _.last(this)
  }
}

if (!Array.prototype.sort2) {
  Array.prototype.sort2 = function (field, direction = 'asc', castTo = '') {
    if (castTo == 'number')
      return this.sort((a, b) => (Number(a[field]) > Number(b[field])) ? (direction == 'asc' ? 1 : -1) : (direction == 'desc' ? 1 : -1))
    return this.sort((a, b) => (a[field] > b[field]) ? (direction == 'asc' ? 1 : -1) : (direction == 'desc' ? 1 : -1))
  }
}


if (!Date.prototype.getUnixTime) {
  Date.prototype.getUnixTime = function () { // eslint-disable-line
    return this.getTime() / 1000 | 0
  }
  if (!Date.now) {
    Date.now = function () {
      return new Date()
    }
  }
  Date.time = function () {
    var now = Date.now()

    if (!isNaN(now)) {
      now = new Date(now)
    }

    return now.getUnixTime()
  }
  Date.nowPretty = function (separator) {
    separator = separator || '-'

    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()

    return `${year}${separator}${month}${separator}${day}`
  }
}

HTMLElement.prototype.select = function (selector) {
  const all = this.selectAll(selector)
  if (all.length > 0) {
    return all[0]
  } else {
    return null
  }
}

HTMLElement.prototype.selectAll = function (selector) {
  return Array.from($(this).find(selector))
}
